import type { OrganizationContextHeaderProps } from "./organization-context-header.type";

import { useOrganizationContextInvalid } from "@/modules/organization/organization-context";

import { OrganizationContextHeader } from "./organization-context-header.component";

export const OrganizationContextHeaderWrapper = (
  props: OrganizationContextHeaderProps
) => {
  const { isInvalid } = useOrganizationContextInvalid();

  if (isInvalid) return null;

  return <OrganizationContextHeader {...props} />;
};
